export default "__VITE_ASSET__lDflGzVw__"